import { z } from 'zod';

/** GET/POST /api/v2/bizy/comment_suggestions response (Key-Inflection: camel). */
export const CommentSuggestionsResponse = z.object({
	suggestions: z.array(z.string()),
	conversationId: z.string().optional(),
});

export type CommentSuggestionsResponse = z.infer<typeof CommentSuggestionsResponse>;

export const commentSuggestionsFixture = (overrides: Partial<CommentSuggestionsResponse> = {}): CommentSuggestionsResponse => ({
	suggestions: ['Nice work on the launch!', 'So well deserved', 'Proud to be on this team'],
	conversationId: 'comment-assist-convo-1',
	...overrides,
});
